import { render, staticRenderFns } from "./v-signup-price.vue?vue&type=template&id=035213ce&scoped=true&"
import script from "./v-signup-price.vue?vue&type=script&lang=js&"
export * from "./v-signup-price.vue?vue&type=script&lang=js&"
import style0 from "./v-signup-price.vue?vue&type=style&index=0&id=035213ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035213ce",
  null
  
)

export default component.exports